import React, { useEffect } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../../redux/actions/CartActions";
import FormalityHeader from "../../../components/header/FormalityHeader";
import "../../styles/flow-form.css";

function ImportationCompanies() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const cart = useSelector((state) => state.cart);
  const { userCompanies } = useSelector((state) => state.companies);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleAddToCart = async (value) => {
    await dispatch(
      addToCart({
        company: value,
      })
    );

    navigate("/importation-type");
  };

  const handleSkipClick = () => {
    navigate(`/importation-business-country`);
  };

  const filteredCompanies = userCompanies.filter((company) => {
    // If the selected service is "importation", only include companies based in Cameroon (CM)
    if (cart.from === "importation") {
      return company.country === "CM";
    }

    return true;
  });

  return (
    <div className="legacy-flow">
      <FormalityHeader from={cart.from} />
      <div className="container my-4">
        <div  className="container text-center my-4" style={{ maxWidth: "800px" }} >
          <h4 className="text-center  mt-4 mb-4">
            Pour quelle <span style={{ color: "#FF5500" }}>entreprise</span>{" "}
            souhaitez-vous souscrire au service{" "}
            <span style={{ color: "#FF5500" }}>
              Inscription au fichier des importateurs
            </span>{" "}
            ?
          </h4>
        </div>

        <Row className="justify-content-center">
          {filteredCompanies.map((company, index) => (
            <Col xs={12} sm={4} md={2} lg={2} key={index} className="mb-4 mx-3">
              <Card
                style={{
                  width: "100%",
                  height: "70px",
                  cursor: "pointer",
                  transition: "0.3s",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  borderRadius: "8px",
                  textAlign: "center",
                  border: "2px solid transparent",
                }}
                className="p-2"
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow =
                    "0 8px 16px rgba(0, 0, 0, 0.2)";
                  e.currentTarget.style.borderColor = "#FF5500";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow =
                    "0 4px 8px rgba(0, 0, 0, 0.1)";
                  e.currentTarget.style.borderColor = "transparent";
                }}
                onClick={() => handleAddToCart(company)}
              >
                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                  <Card.Title style={{ fontSize: "1rem", fontWeight: 400 }}>
                    {company.businessName}
                  </Card.Title>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        <div className="container text-center mt-3">
          <span
            onClick={handleSkipClick}
            style={{
              color: "#3392FF",
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            Autre entreprise
          </span>
        </div>
      </div>
    </div>
  );
}

export default ImportationCompanies;
